import { TextareaAutosize, useMediaQuery, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { BudgetContext } from "../../../../../../../../hooks/ContextStore";
import ActionButton from "../../../../../../../modules/CustomizeComponent/ActionButton";

export default function CreateInsurance(props) {
  const theme = useTheme();
  const [stats,setStats] = useContext(BudgetContext);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    insurance,
    handleClose,
    handleClickOpen,
    open,
    client_case_id,
  } = props;

  const insure = insurance
    ? insurance.filter(
        (pay) => pay.title === "Life Insurance (if not deducted from paycheck)"
      )
    : 0;
  const [description, setDescription] = useState(null);
  const disable = props.disable;

  const { register, getValues } = useForm({
    mode: "onBlur",
  });

  const postMethod = async(data)=>{
    try {
      const response = await Axios
        .post("api/budget/expense", data)
        .catch((err) => {
          if (err && err.response) console.log("Error", err);
        });

      if (response) {
        let firstTimeData = Object(response.data).hasOwnProperty('data');
        let totalOverview = {};
        if(firstTimeData){
          totalOverview = {
            shortfall: response.data.data[0].shortfall,
            total_expenses: response.data.data[0].total_expenses,
            total_gross_income: response.data.data[0].total_gross_income,
            total_net_income: response.data.data[0].total_net_income,
          };
        }else{
          totalOverview = {
            shortfall: response.data.shortfall,
            total_expenses: response.data.total_expenses,
            total_gross_income: response.data.total_gross_income,
            total_net_income: response.data.total_net_income,
          };
        }
        
        setStats(totalOverview);

      }
    } catch (error) {
      if (error.response.status === 500) {
        console.log(error.response.status);
      }
    }
  }


  const formChangedSpouse = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-insurance",
      title: "Life Insurance (if not deducted from paycheck)",
      client_case_id: client_case_id,
      actual_amount: formValues.actual_amount !== '' ? formValues.actual_amount : 0,
      projected_amount: formValues.projected_amount !== '' ? formValues.projected_amount : 0,
    };

    postMethod(data);
  };

  const formChangedDescription = () => {
    
    const formValues = getValues();

    const data = {
      slug: "monthly-insurance",
      description: formValues.description,
      client_case_id: client_case_id,
    };

    Axios.post("api/budget/description/store", data)
      .then((res) => {
        
      })
      .catch((err) => {
        
      });
  };

  const fetchDescription = () => {
    Axios.get(
      "api/budget/description/" + client_case_id + "/" + "monthly-insurance"
    )
      .then((res) => {
        setDescription(res.data.data);
      })
      .catch((err) => {
        
      });
  };
   const handleSubmit = () => {
    formChangedSpouse();
    formChangedDescription();
    handleClose();
   }
  useEffect(() => {
    fetchDescription();
  }, []);

  const numInputs = document.querySelectorAll('input[type=number]')

  numInputs.forEach(function(input) {
    input.addEventListener('change', function(e) {
      if (e.target.value == '') {
        e.target.value = 0;
      }
    })
  })
  
  return (
    <div>
      <ActionButton
        disabled={disable}
        onClick={handleClickOpen}
        type="button"
        className="btn btn-primary"
      >
        Edit/Add
      </ActionButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        fullScreen={fullScreen}
        maxWidth={"lg"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Life Insurance"}</DialogTitle>
        <DialogContent>
          <Row className="mb-4">
            <Col>
              {/* <Form.Label className="form-control border-0">Expense</Form.Label> */}
            </Col>
            <Col>
              <Form.Label className="form-control border-0">
                Actual amount
              </Form.Label>
            </Col>
            <Col>
              <Form.Label className="form-control border-0">
                Projected (future) amount
              </Form.Label>
            </Col>
          </Row>
          <Row className="m-3">
            <Col>
              <Form.Label className="form-control border-0">
                Life Insurance (if not deducted from paycheck)
              </Form.Label>
            </Col>
            <Col>
              <input
                name="actual_amount"
                className={`form-control form-control-solid h-auto py-5 px-6 my-2`}
                type="number"
                defaultValue={insure.length <= 0 ? 0 : insure[0].actual_amount}
                {...register("actual_amount", { required: true })}
                // onBlur={formChangedSpouse}
              />
            </Col>
            <Col>
              <input
                name="projected_amount"
                className={`form-control form-control-solid h-auto py-5 px-6 my-2`}
                type="number"
                defaultValue={
                  insure.length <= 0 ? 0 : insure[0].projected_amount
                }
                {...register("projected_amount", { required: true })}
                // onBlur={formChangedSpouse}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Label className="form-control border-0">
                *If you feel that you need to explain any of the above further,
                please use the space below to do so:
              </Form.Label>
              <TextareaAutosize
                className={`form-control`}
                aria-label="minimum height"
                minRows={4}
                name="description"
                type="text"
                defaultValue={description ? description.description : ""}
                {...register("description", { required: true })}
                // onBlur={formChangedDescription}
              />
            </Col>
          </Row>
        </DialogContent>
        <DialogActions>
              <ActionButton
                id="kt_login_signin_submit"
                onClick={handleSubmit}
                className={`btn custom-green-button font-weight-bold px-9 py-4 my-3`}
              >
                <span>Submit</span>
              </ActionButton>
            <Button
              onClick={handleClose}
              className={`btn custom-cancel-button font-weight-bold px-9 py-4 my-3`}
            >
              Cancel
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
